import { useCallback } from 'react';

const sounds = {
  click: new Audio('/sounds/click.mp3'),
  select: new Audio('/sounds/select.mp3'),
  success: new Audio('/sounds/success.mp3')
};

type SoundName = keyof typeof sounds;

export const useSound = () => {
  const playSound = useCallback((soundName: SoundName) => {
    const sound = sounds[soundName];
    if (sound) {
      sound.currentTime = 0;
      sound.play().catch(() => {
        // Silently fail if sound can't be played
        // This is common when user hasn't interacted with the page yet
      });
    }
  }, []);

  return { playSound };
};